import React from 'react'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { Paper } from '@material-ui/core'
import classNames from 'classnames'
import groupBy from 'lodash/groupBy'
import NoDistributorData from '~components/templates/DistributorAssignmentPopupTemplate/NoDistributorData'
import IntlUtil from 'shared-ui/utils/IntlUtil'
import PortalLabels from '~src/constants/PortalLabels'

const AccountsGridView = props => {
  const {
    accounts,
    selectedAccountId,
    onAccountChange,
    onMoreClicked,
    canAddDistributors,
    distributorAssignments = [],
  } = props

  const _handleAccountMoreClick = (e, account) => {
    e.stopPropagation()
    onMoreClicked && onMoreClicked(account)
  }

  const distributorByAccoutCode = groupBy(distributorAssignments, 'accountCode')

  return (
    <div className="flex gap-4 overflow-scroll md:grid md:grid-cols-3">
      {accounts.map(account => {
        const { _id, accountName, address, accountCode } = account

        let noData = null
        const noDistributor = distributorByAccoutCode[accountCode]?.length
        const noDefaultDistributorCustomerId = distributorAssignments.find(
          x => x.accountCode === accountCode && x.isPrimary && !x.customerId,
        )

        if (noDefaultDistributorCustomerId)
          noData = {
            title: IntlUtil.label(PortalLabels.WS_ENTER_CUSTOMER_ID),
            buttonText: IntlUtil.label(PortalLabels.WS_ADD_ID),
            outerClassName: 'mt-4',
            buttonClassName: 'w-auto',
          }

        const isSelected = _id === selectedAccountId
        return (
          <>
            <Paper
              onClick={() => onAccountChange && onAccountChange(_id)}
              elevation={0}
              className={classNames(
                'border-grey-200 !rounded-outer relative flex min-w-[60%] flex-1 cursor-pointer flex-col items-start justify-start gap-y-4 border p-6 pl-4 pr-4 md:w-full',
                {
                  ['!border-accent-400']: isSelected,
                },
              )}
            >
              <div className="flex w-full flex-col items-start justify-between gap-y-3">
                <Typography variant="h6">{accountName}</Typography>
                <Typography variant="body2">{address}</Typography>
              </div>
              <div className={'absolute right-3 top-3'}>
                <IconButton onClick={e => _handleAccountMoreClick(e, account)}>
                  <Icon>more_vert</Icon>
                </IconButton>
              </div>
              {canAddDistributors && (!noDistributor || noDefaultDistributorCustomerId) && (
                <NoDistributorData {...noData} accountCode={accountCode} />
              )}
            </Paper>
          </>
        )
      })}
    </div>
  )
}

export default AccountsGridView
